import { render, staticRenderFns } from "./Ninjas.vue?vue&type=template&id=7043b966&scoped=true&"
import script from "./Ninjas.vue?vue&type=script&lang=js&"
export * from "./Ninjas.vue?vue&type=script&lang=js&"
import style0 from "./Ninjas.vue?vue&type=style&index=0&id=7043b966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043b966",
  null
  
)

component.options.__file = "Ninjas.vue"
export default component.exports